import '../../../styles/activeCalendar.scss';
import React, { Component } from 'react';
import { ListView, Toast } from 'antd-mobile';
import { list, authority, getHaveClassDateList } from '../../../services/saas/active';
import Calendar from '../../../components/calendar';
import moment from 'moment';
import { getUser, toConference, checkLogin, getApp } from '../../../utils';

const pageSize = 4;

const dataS = new ListView.DataSource({
  getRowData: (dataBlob, sectionID, rowID) => {
    return dataBlob[sectionID][rowID];
  },
  rowHasChanged: (row1, row2) => row1 !== row2,
});

function ListWrap(props) {
  return <ul className="active-list">{props.children}</ul>;
}

export default class ActiveCalendar extends Component {
  state = {
    dataSource: dataS,
    pageIndex: 0,
    data: [],
    hasMore: true,
    loading: false,
    startTime: moment().format('YYYY-MM-DD'),
    dotList: [],
  };

  componentDidMount() {
    this.getData(1);
    this.getDateDot(moment().format('YYYY-MM'));
  }

  getDateDot = async (currentMonth) => {
    const param = {
      releaseStatus: 1,
      finished: 0,
      currentMonth,
    };
    const responsive = await getHaveClassDateList(param);
    if (responsive.success && responsive.data) {
      this.setState({
        dotList: responsive.data.map((item) => `${currentMonth}-${item > 10 ? item : `0${item}`}`),
      });
    }
  };

  getData = async (page) => {
    await this.setState({ loading: true });
    const { appId } = getApp() || {};
    const { data, dataSource, startTime } = this.state;
    const param = {
      current: page,
      size: pageSize,
      releaseStatus: 1,
      finished: 0,
      startTime: `${startTime} 00:00:00`,
      endTime: `${startTime} 23:59:59`,
      sourceApp: appId,
    };
    const respActive = await list(param);
    const statusMapper = new Map([
      [0, { text: '即将开始', className: 'will' }],
      [1, { text: '进行中', className: 'ing' }],
      [2, { text: '已结束', className: 'end' }],
    ]);
    if (respActive.success && respActive.data) {
      const activeList = (page === 1 ? [] : data).concat(
        respActive.data.records.map((item) => ({
          title: item.lessonName,
          classroom: item.cloudClassroomName,
          startTime: item.startTime,
          duration: moment(item.endTime).diff(item.startTime),
          lessonId: item.id,
          liveBroadcast: item.liveBroadcast,
          status: statusMapper.get(this.checkStatus(item.startTime, item.endTime)),
        })),
      );
      this.setState({
        loading: false,
        data: activeList,
        dataSource: dataSource.cloneWithRows(activeList),
        hasMore: respActive.data.current < respActive.data.pages,
        pageIndex: page,
      });
    }
  };

  checkStatus = (startTime, endTime) => {
    let status;
    if (moment().isBefore(startTime)) {
      status = 0;
    } else if (moment().isBetween(startTime, endTime)) {
      status = 1;
    } else if (moment().isAfter(endTime)) {
      status = 2;
    }
    return status;
  };

  onEndReached = () => {
    const { loading, hasMore } = this.state;
    let { pageIndex } = this.state;
    if (!loading && hasMore) {
      this.getData(++pageIndex);
    }
  };

  dateChange = async (date) => {
    await this.setState({ startTime: date });
    this.getData(1);
  };

  monthChange = (month) => {
    this.getDateDot(month);
  };

  forwordTo = async (lessonId, status) => {
    if (status.className === 'will') {
      Toast.info('课程尚未开始');
      return;
    } else if (status.className === 'end') {
      Toast.info('课程已结束');
      return;
    }
    const { userId } = getUser();
    try {
      const resp = await authority({
        lessonId,
        userId,
      });
      if (resp && resp.success && resp.data) {
        if (resp.data.permission === 1) {
          if (!resp.data.isFull) {
            toConference(resp.data);
          } else {
            Toast.info(resp.data.message || '参与人数已达到上限');
          }
        } else {
          Toast.info(resp.data.message || '无权限参加教研活动！');
        }
      } else {
        Toast.info(resp.message || '查询错误');
      }
    } catch (err) {
      Toast.info(err);
    }
  };

  render() {
    const { dataSource, loading, hasMore, dotList } = this.state;
    const row = (rowData, sectionID, rowID) => {
      const { title, classroom, status, duration, startTime, lessonId } = rowData;
      return (
        <li
          className={status.className}
          key={rowID}
          onClick={() =>
            checkLogin({
              onLogin: () => {
                this.forwordTo(lessonId, status);
              },
            })
          }
        >
          <div className="active-info">
            <h1>{title}</h1>
            <p>举办方：{classroom}</p>
            <p>时长：{moment(duration).format('DD天mm分ss秒')}</p>
          </div>
          <em className="active-duration">{startTime}</em>
          <em className="active-arrow-right" />
        </li>
      );
    };
    return (
      <div className="active-calendar">
        <Calendar onChange={this.dateChange} dotList={dotList} onMonthChange={this.monthChange} />
        <div className="active-list-container">
          <ListView
            dataSource={dataSource}
            renderHeader={null}
            renderFooter={() => (
              <div style={{ padding: 30, textAlign: 'center' }}>
                {hasMore ? (loading ? '加载中...' : '加载完成') : '没有更多'}
              </div>
            )}
            renderBodyComponent={() => <ListWrap />}
            renderRow={row}
            className="active-list-wrap"
            pageSize={pageSize}
            onScroll={() => {
              console.log('scroll');
            }}
            scrollRenderAheadDistance={500}
            onEndReached={this.onEndReached}
            onEndReachedThreshold={10}
          />
        </div>
      </div>
    );
  }
}
